export const componentState = {
    methods: {
        $_setState(state: string = null, next: string, timeout: number = 2000) {
            if (!this.states) {
                throw "Component must have 'states' in data to change state";
            }

            const statesValues = Object.values(this.states);

            if (state) {
                if (!statesValues.includes(state)) {
                    throw `Component is not supporting state '${state}'`;
                }

                this.state = state;
            }

            if (next) {
                if (!statesValues.includes(next)) {
                    throw `Component is not supporting next state '${state}'`;
                }
                return new Promise((resolve) => {
                    setTimeout(() => {
                        this.$_setState(next);
                        resolve(next);
                    }, timeout);
                });
            }
        },

        $_stateIs(states: string | string[]) {
            return (Array.isArray(states) ? states : [states]).includes(this.state);
        },
    },
};
